import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsTextEllipsisAppend]'
})
export class TextEllipsisAppendDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  @Input() hide = false;
}
